module.exports = __webpack_public_path__ + "img/NL7715532.fa6461aa.png";